module.exports = __webpack_public_path__ + "img/deleteIcon.d15f668d.svg";